export default __webpack_public_path__ + "static/media/moreOption.20ef8fc3.svg";